import React from 'react'
import { useTranslation } from 'react-i18next'

function ConsignmentItemsTablePlaceHolderRows({
  numberOfItems,
}: { numberOfItems: number }) {
  const { t } = useTranslation()
  return (
    <>
      {Array.from({ length: numberOfItems }, (_, index) => (
        <div
          className="col-12 row m-0"
          key={`goods_item_row_wrapper_${index}`}
        >
          <div
            key={`goods_item_row_header_${index}`}
            className="heading mb-2"
            data-bs-toggle="collapse"
            data-bs-target={`#${index}`}
            aria-controls={`${index}`}
            role="button"
          >
            <h4 className="col-11 d-flex">
              <span className="col-1">
                <span>{t('declaration.p5.sequenceNumber')}</span>
                <span className="px-1">{(index ?? 0) + 1}</span>
              </span>
              <span className="col-10 pe-1">
            &nbsp;
              </span>
              <span className="col-2 px-1">
            &nbsp;
              </span>
            </h4>
            <i className="me-2 fa fa-chevron-down" />
          </div>
        </div>
      ))}
    </>
  )
}

export default ConsignmentItemsTablePlaceHolderRows
